import { defineMessage } from 'react-intl';
export var DeviceType;
(function (DeviceType) {
    DeviceType["MACOS"] = "macos";
    DeviceType["WINDOWS"] = "windows";
})(DeviceType || (DeviceType = {}));
export var KeyboardShortcutType;
(function (KeyboardShortcutType) {
    KeyboardShortcutType["NEW_THREAD"] = "NEW_THREAD";
    KeyboardShortcutType["STOP_GENERATING"] = "STOP_GENERATING";
    KeyboardShortcutType["TOGGLE_INCOGNITO"] = "TOGGLE_INCOGNITO";
    KeyboardShortcutType["TOGGLE_SIDEBAR"] = "TOGGLE_SIDEBAR";
    KeyboardShortcutType["SHOW_SHORTCUTS"] = "SHOW_SHORTCUTS";
    KeyboardShortcutType["FOCUS_ASK_INPUT"] = "FOCUS_ASK_INPUT";
    KeyboardShortcutType["TOGGLE_DICTATION"] = "TOGGLE_DICTATION";
    KeyboardShortcutType["TOGGLE_V2V"] = "TOGGLE_V2V";
})(KeyboardShortcutType || (KeyboardShortcutType = {}));
export const SHORTCUTS_STORAGE_KEY = 'keyboard-shortcuts';
// Initialize with empty arrays for all shortcut types
export const BLANK_SHORTCUTS = {
    [KeyboardShortcutType.NEW_THREAD]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.STOP_GENERATING]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.TOGGLE_INCOGNITO]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.TOGGLE_SIDEBAR]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.SHOW_SHORTCUTS]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.FOCUS_ASK_INPUT]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.TOGGLE_DICTATION]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
    [KeyboardShortcutType.TOGGLE_V2V]: {
        [DeviceType.MACOS]: [],
        [DeviceType.WINDOWS]: [],
    },
};
export const DEFAULT_SHORTCUTS_MAP = {
    [KeyboardShortcutType.STOP_GENERATING]: {
        type: KeyboardShortcutType.STOP_GENERATING,
        label: defineMessage({
            defaultMessage: 'Stop Generating',
            description: 'Label for the keyboard shortcut that stops AI response generation',
            id: 'ac101e2076',
        }),
        macos: ['Esc'],
        windows: ['Esc'],
        editable: false,
    },
    [KeyboardShortcutType.NEW_THREAD]: {
        type: KeyboardShortcutType.NEW_THREAD,
        label: defineMessage({
            defaultMessage: 'New Session',
            description: 'Label for the keyboard shortcut that creates a new conversation thread',
            id: 'eb3b1320bf',
        }),
        macos: ['⌘', 'K'],
        windows: ['Ctrl', 'I'],
        editable: true,
        global: true,
    },
    [KeyboardShortcutType.TOGGLE_INCOGNITO]: {
        type: KeyboardShortcutType.TOGGLE_INCOGNITO,
        label: defineMessage({
            defaultMessage: 'Toggle Incognito',
            description: 'Label for the keyboard shortcut that toggles incognito/private mode',
            id: '912a8a1890',
        }),
        macos: ['⌘', ';'],
        windows: ['Ctrl', ';'],
        editable: false,
    },
    [KeyboardShortcutType.TOGGLE_SIDEBAR]: {
        type: KeyboardShortcutType.TOGGLE_SIDEBAR,
        label: defineMessage({
            defaultMessage: 'Toggle Sidebar',
            description: 'Label for the keyboard shortcut that toggles the sidebar open or closed',
            id: '87cb377521',
        }),
        macos: ['⌘', '.'],
        windows: ['Ctrl', '.'],
        editable: false,
    },
    [KeyboardShortcutType.SHOW_SHORTCUTS]: {
        type: KeyboardShortcutType.SHOW_SHORTCUTS,
        label: defineMessage({
            defaultMessage: 'Show Shortcuts',
            description: 'Label for the keyboard shortcut that displays the keyboard shortcuts panel',
            id: '1a5ee274b1',
        }),
        macos: ['⌘', '/'],
        windows: ['Ctrl', '/'],
        editable: false,
    },
    [KeyboardShortcutType.FOCUS_ASK_INPUT]: {
        type: KeyboardShortcutType.FOCUS_ASK_INPUT,
        label: defineMessage({
            defaultMessage: 'Focus Ask Input',
            description: 'Label for the keyboard shortcut that focuses the search/ask input field',
            id: '83ab14a407',
        }),
        macos: ['⌘', 'J'],
        windows: ['Ctrl', 'J'],
        editable: false,
    },
};
export const DEFAULT_SHORTCUTS = Object.values(DEFAULT_SHORTCUTS_MAP);
//# sourceMappingURL=consts.js.map